const parseDate = (value?: string | null): number | undefined => {
  if (!value) return undefined;

  const timestamp = Date.parse(value);
  return Number.isFinite(timestamp) ? timestamp : undefined;
};

const startOfUtcMonth = (timestamp: number): number => {
  const date = new Date(timestamp);
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1, 0, 0, 0, 0);
};

export const xAxisRangeFromFilters = (
  filters: unknown,
  dateKeys: string[] = ['published_at', 'created_at', 'detected_at', 'updated_at']
): { min?: number; max?: number } => {
  if (!Array.isArray(filters)) return {};

  const matchingFilter = filters.find((entry) => {
    if (typeof entry !== 'string') return false;
    return dateKeys.some((key) => entry.startsWith(`${key}:`));
  }) as string | undefined;

  if (!matchingFilter) return {};

  const [, range] = matchingFilter.split(':');
  if (!range) return {};

  const [fromRaw, toRaw] = range.split('/').map((value) => value.trim());

  const fromTimestamp = parseDate(fromRaw);
  const toTimestamp = parseDate(toRaw);

  if (fromTimestamp == null || toTimestamp == null) return {};

  return {
    min: startOfUtcMonth(fromTimestamp),
    max: startOfUtcMonth(toTimestamp),
  };
};
